import $ from 'jquery';
import 'slick-carousel';
import { userSubscribe } from '../../modules/userSubscribe';

export const appIndex = () => {
  userSubscribe();

  $('.js-highlights').slick({
    arrows: true,
    dots: false,
    infinite: true,
    rows: 0,
    mobileFirst: true,
    prevArrow: '<button class="o-btn-arrow o-btn-arrow--prev slick-arrow slick-prev"></button>',
    nextArrow: '<button class="o-btn-arrow o-btn-arrow--next slick-arrow slick-next"></button>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  });

  $('.js-cards').slick({
    arrows: true,
    dots: false,
    infinite: true,
    rows: 0,
    mobileFirst: true,
    prevArrow: '<button class="o-btn-arrow o-btn-arrow--prev slick-arrow slick-prev"></button>',
    nextArrow: '<button class="o-btn-arrow o-btn-arrow--next slick-arrow slick-next"></button>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
        },
      },
    ],
  });
};
